import { render, staticRenderFns } from "./FilesPanel.vue?vue&type=template&id=da45a62e&"
import script from "./FilesPanel.vue?vue&type=script&lang=js&"
export * from "./FilesPanel.vue?vue&type=script&lang=js&"
import style0 from "./FilesPanel.vue?vue&type=style&index=0&id=da45a62e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports